const { Box, Typography, Divider, Chip, useTheme } = require("@mui/material");


const Overview = ({ data }) => {
    const theme= useTheme();
    const summary = data?.analysis?.transcript_summary || "No summary available";
    const evolution = data?.analysis?.evaluation_criteria_results?.evaluation?.rationale || "No evolution available";
    const evolutionStatus = data?.analysis?.evaluation_criteria_results?.evaluation?.result;

    const getEvolutionStatus = (status) => {
        switch (status) {
            case "success":
                return "Success";
            case "failure":
                return "Failure";
            default:
                return status || "Unknown";
        }
    };

    const getEvolutionStatusColor = (status) => {
        switch (status) {
            case "success":
                return "#00AA38";
            case "failure":
                return "#FF0000";
            default:
                return "#000000";
        }
    };

    const getEvolutionStatusBackgroundColor = (status) => {
        switch (status) {
            case "success":
                return "#E6FFED";
            case "failure":
                return "#FFE6E6";
            default:
                return "#FFFFFF";
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
            }}
            aria-label="Call overview"
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 1,
                    alignItems: "start",
                    gap: 2,
                }}
            >
                <Typography variant="h6" sx={{color:theme.palette.text.primary}}>
                    Call Summary
                </Typography>
                <Typography variant="body2" sx={{color:theme.palette.text.primary}}>
                    {summary}
                </Typography>
            </Box>
            <Divider variant="fullWidth" />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 1,
                    alignItems: "start",
                    gap: 2,
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Typography variant="h6" sx={{color:theme.palette.text.primary}}>
                        Call Evolution
                    </Typography>
                    {evolutionStatus && (
                        <Chip
                            label={getEvolutionStatus(evolutionStatus)}
                            sx={{
                                color: getEvolutionStatusColor(evolutionStatus),
                                backgroundColor: getEvolutionStatusBackgroundColor(evolutionStatus),
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "4px 8px",
                                borderRadius: "16px",
                            }}
                        />
                    )}
                </Box>
                <Typography variant="body2" sx={{color:theme.palette.text.primary}}>
                    {evolution}
                </Typography>
            </Box>
            <Divider variant="fullWidth" />
        </Box>
    )
}

export default Overview;